import { render } from "./AdSenseAd.vue?vue&type=template&id=40a8ead9&scoped=true"
import script from "./AdSenseAd.vue?vue&type=script&lang=js"
export * from "./AdSenseAd.vue?vue&type=script&lang=js"

import "./AdSenseAd.vue?vue&type=style&index=0&id=40a8ead9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a8ead9"]])

export default __exports__